import loadable from '@loadable/component';

// 懒加载组件
const ImplantableDeliveryManagement = loadable(() => import('./implantableDeliveryManagement/ImplantableDeliveryManagement'));
const ImplantableDeliveryDetailModify = loadable(() => import('./implantableDeliveryManagement/implantableDeliveryDetailModify/ImplantableDeliveryDetailModify'));
const ImplantationOrderManagement = loadable(() => import('./implantationOrderManagement/ImplantationOrderManagement'));


export const subRoutes = [
  {
    path: '/ImplantableDeliveryManagement',
    component: ImplantableDeliveryManagement
  },
  {
    path: '/ImplantableDeliveryDetailModify',
    component: ImplantableDeliveryDetailModify
  },
  {
    // 801253013供应商：植入性订单响应-
    path: '/ImplantationOrderManagement',
    component: ImplantationOrderManagement
  }
];
